import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';

export enum Regex {
	taxcode = '^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$',
	vatcode = '^[0-9]{11}$',
	numbers = '^[0-9]*$',
	letters = '^[a-zA-Z]+$',
	password = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$',
	expireData = '^(1[0-2]|0[1-9])\\/(1[5-9]|2\\d)$',
	iban_it = '^IT\\d{2}[A-Z]\\d{10}[0-9A-Z]{12}$',
	numeroCellulare = '^3[0-9]{2}-[0-9]{6,7}$',
	currency = '^(\\b\\d[\\d,.]*\\b)$'
}

export interface LoadedDocument {
	codiceTipoDocumento: string;
	numeroPagina: number;
	flagInviatoCnt: boolean;
	flagConfermato: boolean;
	descrizioneTipoDocumento: string;
}
export interface RequestedDocument {
	codiceTipoDocumento: string;
	descrizioneTipoDocumento: string;
	nDocumentiCaricati?: number;
}

export interface Documents {
	documentiCaricati: LoadedDocument[];
	documentiRichiesti: RequestedDocument[];
}

export const AGOS_HEADER = 'Agos-Header';
export const headers_agos = new HttpHeaders({ [AGOS_HEADER]: '' });
export const INSERT_PARAMS_HEADER = 'Agos-Insert-Params';
export const headers_insert_params = new HttpHeaders({ [INSERT_PARAMS_HEADER]: '' });
export const SKIP_TOKEN_HEADER = 'Agos-Skip-Token';
export const headers_skip_token = new HttpHeaders({ [SKIP_TOKEN_HEADER]: '' });
export const SKIP_LOADER_HEADER = 'Agos-Skip-Loader';
export const headers_skip_loader = new HttpHeaders({ [SKIP_LOADER_HEADER]: '' });
export const ACCESS_TOKEN_HEADER = 'Agos-Access-Token';
export const headers_access_token = new HttpHeaders({ [ACCESS_TOKEN_HEADER]: '' });

export const dateFormats: string[] = [
	'dd/MM/yyyy',
	'dd/MM/yyyy hh:mm:ss',
	'dd-MM-yyyy',
	'dd-MM-yyyy HH:mm:ss',
	'MM/dd/yyyy',
	'MM/dd/yyyy hh:mm:ss',
	'yyyy/MM/dd',
	'yyyy/MM/dd HH:mm:ss',
	'dd/MM/yy',
	'dd/MM/yy hh:mm:ss',
];

@Injectable({
	providedIn: 'root'
})
export class UtilityService {
	Regex: typeof Regex = Regex;

	// hostListenerReload;

	private emitClickPopup = new Subject<any>();
	clickPopup$ = this.emitClickPopup.asObservable();

	/**
	 * notify click popup
	 */
	notifyClickPopup() {
		this.emitClickPopup.next();
	}
}
